import { PlaceActionType } from './place-action-type';
import { PlaceEntry } from '../../state';

export interface LoadPlaceAction {
  placeKey: string;
  place?: Partial<PlaceEntry['place']>;
  type: PlaceActionType.LoadPlace;
}

export const loadPlace = (
  placeKey: string,
  place?: Partial<PlaceEntry['place']>,
): LoadPlaceAction => ({
  placeKey,
  place,
  type: PlaceActionType.LoadPlace,
});
